export default __webpack_public_path__ + "static/media/earning.97397a17.jpg";